import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Theme,
  Typography,
} from "@mui/material";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";

interface GenericModalProps {
  onClick?: () => void;
  onCancel?: () => void;
  title?: string;
  description: string | React.ReactNode;
  submitText?: string;
  cancelText?: string;
  isLoading?: boolean;
  icon?: React.ReactNode;
  showIcon?: boolean;
  theme?: Theme;
  showFotter?: boolean;
  style?: React.CSSProperties;
}

const GenericAlertModal: React.FC<GenericModalProps> = ({
  onClick,
  onCancel,
  title,
  description,
  submitText,
  cancelText,
  isLoading,
  icon,
  showIcon = false,
  theme,
  showFotter = true,
  style,
}) => {
  return (
    <Dialog
      open={true}
      onClose={onCancel}
      onBackdropClick={onCancel}
      PaperProps={{
        style: {
          width: "100%",
          maxWidth: "280px",
          display: "flex",
          backgroundColor: "#DED9F8", // Light purple background
          textAlign: "center",
          borderRadius: "28px",
          minHeight: "200px",
          ...style,
        },
      }}
    >
      {isLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="200px"
          padding="24px"
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {showIcon && (
            <div style={{ marginTop: "1.5rem" }}>
              {icon || <CancelPresentationIcon fontSize="medium" />}
            </div>
          )}
          {title && (
            <DialogContent
              style={{
                textAlign: "left",
                padding: "2.25rem 1.25rem 0.75rem 1.25rem",
              }}
            >
              <Typography variant="headlineMedium" color="#232B36">
                {title}
              </Typography>
              <DialogContentText variant="bodySmall" color="#232B36">
                {description}
              </DialogContentText>
            </DialogContent>
          )}
          {!title && (
            <DialogContent
              style={{
                textAlign: "left",
                padding: "2.25rem 1.25rem 0.75rem 1.25rem",
              }}
            >
              <DialogContentText variant="bodySmall" color="#232B36">
                {description}
              </DialogContentText>
            </DialogContent>
          )}

          {showFotter && (
            <DialogActions
              style={{
                paddingRight: "24px",
                paddingBottom: "24px",
                borderTop: "none",
              }}
            >
              {cancelText && (
                <Button
                  onClick={onCancel}
                  variant="text"
                  style={{
                    color: "#7262B4",
                    textTransform: "capitalize",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  {cancelText}
                </Button>
              )}
              <Button
                onClick={onClick}
                variant="text"
                style={{
                  color: "#7262B4",
                  textTransform: "capitalize",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                {submitText}
              </Button>
            </DialogActions>
          )}
        </>
      )}
    </Dialog>
  );
};
export default GenericAlertModal;
